<!-- src/layouts/LobbyLayout.vue -->
<template>
    <div>
      <AppHeader :variant="'lobby'" />
      <!-- search + deposit; no register/login -->

      <div id="app-container">
        <div class="container">
          <div class="row">
            <div class="col-12">
              <div id="OtherGamesMainContainer">
                <!-- Side Menu (optional slot/component to match design) -->
                <SideMenu class="side-menu-content" id="sideMenuBar" />

                <div id="OtherGamesMainContainerLobby">
                  <!-- Render the active route here -->
                  <RouterView />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />

      <!-- Sticky footer variant for lobbies -->
      <div id="instantGamesFooter" class="footer-nav position-fixed">
        <div class="container">
          <div class="row">
            <div class="col-12 px-0">
              <div class="footer-content">
                <div class="page-nav">
                  <RouterLink id="menu" :to="{ name: 'home' }">
                    <i class="fi fi-rr-home"></i>
                    <span class="text">Home</span>
                  </RouterLink>
                </div>

                <div class="page-nav">
                  <RouterLink class="active-page" :to="{ name: 'casino-games' }" id="instantGames">
                    <i class="fi fi-rr-spade"></i>
                    <span class="text">Casino</span>
                  </RouterLink>
                </div>

                <div class="page-nav">
                  <RouterLink :to="{ name: 'promotion' }" id="instantGamesPromos">
                    <i class="fi fi-sr-gift"></i>
                    <span class="text">Promotions</span>
                  </RouterLink>
                </div>

                <div class="page-nav">
                  <RouterLink :to="{ name: 'my-account' }" id="my-account">
                    <i class="fi fi-rr-user"></i>
                    <span class="text">Account</span>
                  </RouterLink>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mobile-auth position-fixed">
        <div class="access-account">
          <RouterLink class="register" :to="{ name: 'register' }">register</RouterLink>
          <RouterLink class="login" :to="{ name: 'login' }">login</RouterLink>
        </div>
      </div>

      <div class="overlay" id="overlay" @click="closeSideMenu"></div>
    </div>
</template>

<script setup>
import { RouterView } from 'vue-router'
import AppHeader from '@/components/AppHeader.vue'
import Footer from '@/components/Footer.vue'
/* Fix case-sensitive import: the file is Sidebar.vue */
import SideMenu from '@/components/SideBar.vue'

function closeSideMenu() {
  const el = document.getElementById('sideMenuBar')
  if (el) el.classList.remove('show', 'open')
  const overlay = document.getElementById('overlay')
  if (overlay) overlay.classList.remove('show', 'open')
}
</script>
